module.exports = __webpack_public_path__ + "img/658-9e5212.png";